import React from 'react';
import { PERMISSIONS } from '../../../constants/permissions';
import OrderThreadsWidget from '../thread/OrderThreadsPanel';
import ShipThisWeekWidget from '../thread/ShipThisWeekPanel';
import { WidgetDef } from './types';

// Opt-in only: these are NOT in any preset or role default. A person adds them from "Add widget".
// Both read the one order dashboard endpoint, so they carry its key (MERCH_REPORT_VIEW).
export const merchandisingWidgets: WidgetDef[] = [
    {
        id: 'merchandising.orderThreads',
        module: 'merchandising',
        title: 'Order threads',
        subtitle: 'Live orders, late first',
        permission: PERMISSIONS.MERCH_REPORT_VIEW,
        size: 'lg',
        component: ({ institutionId }) => <OrderThreadsWidget institutionId={institutionId} />,
    },
    {
        id: 'merchandising.shipThisWeek',
        module: 'merchandising',
        title: 'Ship this week',
        subtitle: 'Orders shipping in the next 7 days',
        permission: PERMISSIONS.MERCH_REPORT_VIEW,
        size: 'md',
        component: ({ institutionId }) => <ShipThisWeekWidget institutionId={institutionId} />,
    },
];
